module.exports = __webpack_public_path__ + "static/media/blom-a-generative-art-series-by-lucastswick-sm-93.58f8b6cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/blom-light/blom-a-generative-art-series-by-lucastswick-sm-93.jpg
// module id = 363
// module chunks = 12